"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newspaper = void 0;
var newspaper = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 4v-2h-14v11c0 0.552 0.448 1 1 1h13.5c0.828 0 1.5-0.672 1.5-1.5v-8.5h-2zM13 13h-12v-10h12v10zM2 5h10v1h-10zM8 7h4v1h-4zM8 9h4v1h-4zM8 11h3v1h-3zM2 7h5v5h-5z"
    }
  }]
};
exports.newspaper = newspaper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/icomoon/newspaper.js
// module id = 393
// module chunks = 0